// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-512b488e] .c-icon svg {\n  top: 0;\n  left: 0;\n  fill: none;\n}\n.status-scheduled-date[data-v-512b488e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-weight: 500;\n  font-size: 12px;\n  margin-top: 7px;\n}\n.status-scheduled-date svg[data-v-512b488e] {\n    margin-right: 7px;\n}\n", ""]);
// Exports
module.exports = exports;
